import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(theme => ({
  sliderContainer: {
    height: theme.spacing(5),
  },
  togglePayRange: {
    background: 'transparent',
    border: 'none',
    color: theme.palette.common.blue400,
    cursor: 'pointer',
    outline: 'none',
    textDecoration: 'underline',
  },
}));

export default useStyles;
